<ng-container *ngIf="state$ | async as state">
  <div *ngIf="state.isLoading" class="overlay" role="alert" aria-live="polite" aria-busy="true"
       [attr.aria-label]="state.activeMessage">

    <div class="card">
      <!-- Company logo -->
      <img src="assets/img/icon.png" alt="Well Chron" class="brand-mark" />

      <!-- Status message -->
      <div class="status">{{ state.activeMessage }}</div>

      <!-- Progress bar -->
      <div class="bar-track" role="progressbar"
           [attr.aria-valuenow]="state.overallProgress"
           aria-valuemin="0" aria-valuemax="100">
        <div class="bar-fill" [style.width.%]="state.overallProgress"></div>
      </div>

      <!-- Concurrent ops indicator -->
      <div class="op-count" *ngIf="state.operations.length > 1">
        {{ state.operations.length }} tasks in progress
      </div>
    </div>
  </div>
</ng-container>
